(function () {
  const STYLE_ID = 'liw-payment-terms-svg-fix';
  const CSS = [
    '#shopify-installments svg{width:43px!important;max-width:43px!important;height:auto!important;}',
    '@media screen and (max-width:719px){',
    '#shopify-installments-content,#shopify-installments-cta{font-size:11px!important;line-height:1.4!important;}',
    '}'
  ].join('');

  function injectInto(termsEl) {
    const root = termsEl.shadowRoot;
    if (!root || root.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    root.appendChild(style);
  }

  function scan() {
    document.querySelectorAll('shopify-payment-terms').forEach(injectInto);
  }

  scan();
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();
